// extracted by mini-css-extract-plugin
export var JobAdsResult = "JobAdResult-module--JobAdsResult--1406d";
export var active = "JobAdResult-module--active--c5ccb";
export var capitalize = "JobAdResult-module--capitalize--06d60";
export var filtersPanels = "JobAdResult-module--filtersPanels--b81b0";
export var filtres = "JobAdResult-module--filtres--a3b39";
export var freeCandidate = "JobAdResult-module--free-candidate--50899";
export var freeCandidateDescription = "JobAdResult-module--free-candidate-description--a78b2";
export var fs14 = "JobAdResult-module--fs-14--beefa";
export var fs16 = "JobAdResult-module--fs-16--eddd8";
export var fs20 = "JobAdResult-module--fs-20--d6382";
export var fs24 = "JobAdResult-module--fs-24--a0a1c";
export var fs32 = "JobAdResult-module--fs-32--975a0";
export var fs40 = "JobAdResult-module--fs-40--31c2d";
export var fsItalic = "JobAdResult-module--fs-italic--238ec";
export var fsLg = "JobAdResult-module--fs-lg--c5280";
export var fsMd = "JobAdResult-module--fs-md--2d596";
export var fsNormal = "JobAdResult-module--fs-normal--1d06c";
export var fsSm = "JobAdResult-module--fs-sm--02b53";
export var fsXl = "JobAdResult-module--fs-xl--f98da";
export var fsXs = "JobAdResult-module--fs-xs--e7c49";
export var fsXxl = "JobAdResult-module--fs-xxl--476af";
export var fsXxs = "JobAdResult-module--fs-xxs--3b2e5";
export var fwBold = "JobAdResult-module--fw-bold--013a8";
export var fwMedium = "JobAdResult-module--fw-medium--4dbf2";
export var fwNormal = "JobAdResult-module--fw-normal--ab9ad";
export var gotham_bold = "JobAdResult-module--gotham_bold--7e6de";
export var gotham_bold_italic = "JobAdResult-module--gotham_bold_italic--74724";
export var gotham_book = "JobAdResult-module--gotham_book--78e53";
export var gotham_book_italic = "JobAdResult-module--gotham_book_italic--e0b1a";
export var gridContainer = "JobAdResult-module--gridContainer--8a871";
export var locationCardDetails = "JobAdResult-module--locationCardDetails--99a37";
export var lowercase = "JobAdResult-module--lowercase--d43b8";
export var resulatButton = "JobAdResult-module--resulatButton--f7e18";
export var results = "JobAdResult-module--results--ed7c0";
export var uppercase = "JobAdResult-module--uppercase--bf686";